import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArchiveJunk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArchiveJunk"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V8.5H21V21ZM12 13.6895L10.0303 11.7197L8.96973 12.7803L10.9395 14.75L8.96973 16.7197L10.0303 17.7803L12 15.8105L13.9697 17.7803L15.0303 16.7197L13.0605 14.75L15.0303 12.7803L13.9697 11.7197L12 13.6895Z" fill="currentColor"/><Path d="M22 7H2V3H22V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArchiveJunk;
